import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import BaseGynObsReport from "./BaseGynObsReport";

const FamilyPlanningRegisterReport = ({ actions }) => (
  <BaseGynObsReport
    title="Family Planning Register Report"
    endpoint="obgyn/reports/family-planning-register"
    actions={actions}
    columns={[
      { key: "provision_date", label: "Provision Date" },
      { key: "patient_number", label: "Patient No." },
      { key: "patient_name", label: "Patient Name" },
      { key: "phone_no", label: "Phone" },
      { key: "client_type", label: "Client Type" },
      { key: "method_provided", label: "Method" },
      { key: "expected_renewal_date", label: "Renewal Date" },
      { key: "status", label: "Status" },
    ]}
  />
);

const mapDispatchToProps = (dispatch) => ({
  actions: {
    snackbarActions: bindActionCreators(snackbarActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(FamilyPlanningRegisterReport);
